import { SvgIcon, type SvgIconProps } from './svgIcon'

export const ReinvestmentEliteIcon = ({
  width = 16,
  height = 14,
  ...props
}: SvgIconProps) => (
  <SvgIcon
    width={width}
    height={height}
    viewBox={`0 0 ${width} ${height}`}
    {...props}>
    <path d="M12.5732 0H2.99844L0 4H16L12.5732 0Z" fill="white" />
    <path d="M0 6L7.99998 14L16 6H0Z" fill="white" />
  </SvgIcon>
)
